import dayjs from 'dayjs'
import type { UnitType } from 'dayjs'

const formatDate = function (value: Date, dateFormat: string) {
  return dayjs(value).format(dateFormat)
}

/**
 * @author PVThang
 * @param {date} date ngày
 * @param {string} dateFormat định dạng
 * @returns thời gian đếm ngược theo định dạng truyền vào
 * DD ngày
 * HH giờ
 * mm phút
 * ss giây
 */
const getTimeRemaining = (date: Date, dateFormat: string) => {
  const total = Math.abs(date.getTime() - new Date().getTime())
  const seconds = Math.floor((total / 1000) % 60)
  const minutes = Math.floor((total / 1000 / 60) % 60)
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24)
  const days = Math.floor(total / (1000 * 60 * 60 * 24))
  let result = dateFormat

  result = result.replace('DD', days.toString())
  result = result.replace('HH', hours.toString())
  result = result.replace('mm', minutes.toString())
  result = result.replace('ss', seconds.toString())

  return result
}

/**
 * @description Thêm phút vào date
 * @param date Date cần thêm
 * @param minutes Số phút cần thêm
 * @returns
 * @author PHNam
 */
const addMinutes = (date: Date, minutes: number): Date => {
  return new Date(date.getTime() + minutes * 60000)
}

/**
 * @description Lấy ngày đầu tuần
 * @param date
 * @returns
 */
export function startOfWeek (date: Date) {
  return dayjs(date).startOf('week').toDate()
}

/**
 * @description Lấy ngày cuối tuần
 * @param date
 * @returns
 */
export function endOfWeek (date: Date) {
  return dayjs(date).endOf('week').toDate()
}

/**
 * @description Lấy ngày đầu tuần và cuối tuần
 * @param date
 * @returns
 */
export function startEndOfWeek (date: Date) {
  return {
    StartWeek: startOfWeek(date),
    EndWeek: endOfWeek(date)
  }
}

/**
 * @description Thêm ngày
 * @param date
 * @param amount
 * @returns
 * @author PHNam
 */
export function addDay (date: Date, amount: number): Date {
  return dayjs(date).add(amount, 'day').toDate()
}

/**
 * @description Bớt ngày
 * @param date
 * @param amount
 * @returns
 * @author PHNam
 */
export function subtractDay (date: Date, amount: number): Date {
  return dayjs(date).subtract(amount, 'day').toDate()
}

export function diff (date: Date, anotherDate: Date, unit: UnitType = 'day', float: false) {
  return dayjs(date).diff(anotherDate, unit, float)
}

export { formatDate, getTimeRemaining, addMinutes }
